"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinPath = exports.splitPath = void 0;
/**
 * 拆解 `foo.bar["x.y.z"]`这种表达式为 `foo` `bar` `x.y.z` 三个字符串
 */
function splitPath(keypath) {
    const ans = [];
    let path = String(keypath);
    while (path) {
        // 匹配 ["foo.bar"] 和 [0] 这种（顺便吃掉末尾的点）
        {
            const mat = /^\[("(?:[^"\\]|\\.)*"|-?\d+)\]\.?/.exec(path);
            if (mat) {
                ans.push(String(JSON.parse(mat[1])));
                path = path.substr(mat[0].length);
                continue;
            }
        }
        // 匹配一般的格式（非 [ 开头，且不含 . ）（规则比较宽松）
        {
            const mat = /^([^.\[\]]+)\.?/.exec(path);
            if (mat) {
                ans.push(mat[1]);
                path = path.substr(mat[0].length);
                continue;
            }
        }
        // 出现错误
        throw new Error("Unknown remainder: " + path);
    }
    return ans;
}
exports.splitPath = splitPath;
function joinPath(parts) {
    let ans = parts.map(x => {
        if (typeof x === 'number')
            return `[${x}]`;
        if (!x)
            return "";
        if (/^[a-zA-Z\d_$][\w$]*$/.test(x))
            return `.${x}`;
        return `[${JSON.stringify(String(x))}]`;
    }).join('');
    if (ans.charAt(0) === '.')
        ans = ans.substr(1);
    return ans;
}
exports.joinPath = joinPath;
//# sourceMappingURL=path.js.map